export async function enableMocking(): Promise<
  ServiceWorkerRegistration | undefined
> {
  if (import.meta.env.MODE !== 'mock') {
    return;
  }

  const { worker } = await import('../../mocks/setupWorker');

  return worker.start({
    onUnhandledRequest: 'warn',
  });
}
